import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { translate } from '../../../../base/i18n/functions';
import Icon from '../../../../base/icons/components/Icon';
import { IconCheck, IconExclamationTriangle } from '../../../../base/icons/svg';
import { connect } from '../../../../base/redux/functions';
import { getDeviceStatusText, getDeviceStatusType } from '../../../functions';
const useStyles = makeStyles()(theme => {
    return {
        deviceStatus: {
            alignItems: 'center',
            color: '#fff',
            display: 'flex',
            fontSize: '14px',
            lineHeight: '20px',
            padding: '6px',
            textAlign: 'center',
            '& span': {
                marginLeft: theme.spacing(3)
            },
            '&.device-status-error': {
                alignItems: 'flex-start',
                backgroundColor: theme.palette.warning01,
                borderRadius: '6px',
                color: theme.palette.uiBackground,
                padding: '12px 16px',
                textAlign: 'left'
            },
            '& .device-icon': {
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: 'inline-block',
                height: '16px',
                width: '16px'
            },
            '& .device-icon--ok svg path': {
                fill: '#189B55'
            }
        }
    };
});
const iconMap = {
    warning: {
        src: IconExclamationTriangle,
        className: 'device-icon--warning'
    },
    ok: {
        src: IconCheck,
        className: 'device-icon--ok'
    }
};
/**
 * Strip showing the current status of the devices.
 * User is informed if there are missing or malfunctioning devices.
 *
 * @returns {ReactElement}
 */
function DeviceStatus({ deviceStatusType, deviceStatusText, t }) {
    const { classes, cx } = useStyles();
    const { src, className } = iconMap[deviceStatusType];
    const hasError = deviceStatusType === 'warning';
    const containerClassName = cx(classes.deviceStatus, { 'device-status-error': hasError });
    return (React.createElement("div", { className: containerClassName, role: 'alert', tabIndex: -1 },
        React.createElement(Icon, { className: `device-icon ${className}`, size: 16, src: src }),
        React.createElement("span", { role: 'heading' }, hasError ? t('prejoin.errorNoPermissions') : t(deviceStatusText !== null && deviceStatusText !== void 0 ? deviceStatusText : ''))));
}
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @returns {{ deviceStatusText: string, deviceStatusText: string }}
 */
function mapStateToProps(state) {
    return {
        deviceStatusText: getDeviceStatusText(state),
        deviceStatusType: getDeviceStatusType(state)
    };
}
export default translate(connect(mapStateToProps)(DeviceStatus));
